var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation_request_type"},[_c('div',{staticClass:"validation_request_type_head"},[_c('h4',[_vm._v(_vm._s(_vm.type.display_name))])]),_vm._v(" "),_c('p',{staticClass:"validation_request_type_description"},[_vm._v("\n    "+_vm._s(_vm.type.description)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8154587a","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/Details/Type.vue
// module id = 1961
// module chunks = 0